<template>
	<div class="container">
		<div style="position:fixed;top:0px;left:0px;right:0px;bottom:0px;">
			<div data-fillout-id="t5mdN9eD35us" data-fillout-embed-type="fullscreen" style="width:100%;height:100%;" data-fillout-inherit-parameters ></div>
		</div>
	</div>
</template>

<script setup>
useHead({
	script: [
		{
			src: "https://server.fillout.com/embed/v1/",
			defer: true
		}
	]
})
</script>

<style lang="scss">
@use '~/assets/scss/components/Form.scss';
</style>